import Down from '@assets/icons/down';
import { Modal } from '@components/1-atoms';
import Input from '@components/2-molecules/Input';
import React, { FC, useEffect, useState } from 'react';
import Button from './Buttons/Button';
import List, { Props as ListProps } from './List';
//import styled from '@emotion/native';
import * as utils from '@lib/utils';

import Add from '@assets/icons/plus';
import { ListItemData } from './ListItem';
const down = <Down />;



const Dropdown: FC<Props> = ({
  onChange,
  data,
  left,
  placeholder = "Please choose",
  defaultValue,
  elective = false,
  ...props
}) => {

  const [isModalVisible, setModalVisiblility] = useState(false);
  const openModal = () => {
    setModalVisiblility(true)
  };
  const closeModal = () => {
    setModalVisiblility(false)
  };

  const [value, setValue] = useState(defaultValue);
  const [text, setText] = useState<string>(value?.name);

  useEffect(() => setValue(defaultValue), [defaultValue]);

  useEffect(() => {
    setText(value?.name);
    onChange?.(value);
  }, [value]);


  const _onPress = (item: ListItemData) => {
    if (utils.deepEqual(value, item)) {
      setValue(null);
    } else {
      setValue(item);
    }
    closeModal();
  };


  return (
    <>
      <Modal title={props.label} visible={isModalVisible} onClose={closeModal}>
        <List data={data} defaultValue={value} onPress={_onPress} />
      </Modal>

      {(elective && !value) ?
        <Button bg={"transparent"} align={'left'} color={"#434BFF"} right={<Add stroke="#434BFF" />} onPress={openModal}>{placeholder}</Button>
        :
        <Input {...props} label={props.label} left={left} autoComplete={"off"} editable={false} right={down} placeholder={placeholder} defaultValue={text} onPress={openModal} />
      }
    </>
  )
};

type Props = ListProps & {
  defaultValue?: string | number | Date | any | null;
  onChange?: (value: null | ListItemData) => void;

  left?: object;
  placeholder?: string;
  label?: string;
  required?: boolean;
  elective?: boolean;
  mini?: boolean;
};

export default Dropdown;